var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25033 1.86475C3.63977 1.86475 3.05423 2.10729 2.62251 2.53901C2.19078 2.97073 1.94824 3.55628 1.94824 4.16683V9.8335C1.94824 10.444 2.19078 11.0296 2.62251 11.4613C3.05423 11.893 3.63978 12.1356 4.25033 12.1356H12.7503C13.3609 12.1356 13.9464 11.893 14.3781 11.4613C14.8099 11.0296 15.0524 10.444 15.0524 9.8335V4.16683C15.0524 3.55628 14.8099 2.97074 14.3781 2.53901C13.9464 2.10729 13.3609 1.86475 12.7503 1.86475H4.25033ZM1.87121 1.78771C2.50219 1.15673 3.35798 0.802246 4.25033 0.802246H12.7503C13.6427 0.802246 14.4985 1.15673 15.1294 1.78771C15.7604 2.41869 16.1149 3.27449 16.1149 4.16683V9.8335C16.1149 10.7258 15.7604 11.5816 15.1294 12.2126C14.4985 12.8436 13.6427 13.1981 12.7503 13.1981H4.25033C3.35798 13.1981 2.50219 12.8436 1.87121 12.2126C1.24022 11.5816 0.885742 10.7258 0.885742 9.8335V4.16683C0.885742 3.27449 1.24022 2.41869 1.87121 1.78771ZM7.35699 4.41959C7.19287 4.32112 6.98847 4.31854 6.82191 4.41284C6.65536 4.50714 6.55241 4.68374 6.55241 4.87514V9.12514C6.55241 9.31653 6.65536 9.49313 6.82191 9.58743C6.98847 9.68173 7.19287 9.67915 7.35699 9.58068L10.8987 7.45568C11.0587 7.35967 11.1566 7.18674 11.1566 7.00014C11.1566 6.81353 11.0587 6.6406 10.8987 6.54459L7.35699 4.41959Z",
    fill: "#3E3E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon1);
export default __webpack_public_path__ + "static/media/file-icon-1.63be47769bb1e1ab6d9b60a39e6fbe31.svg";
export { ForwardRef as ReactComponent };